export * from './list/estudantilList.component';
export * from './create/estudantilCreate.component';
export * from  './edit/estudantilEdit.component';
export * from './detail/estudantilDetail.component';
export * from './search/estudantilSearch.component';